import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'v4-connect-with-xhs',
  templateUrl: './connect-with-xhs.component.html',
  styleUrls: ['./connect-with-xhs.component.scss'],
})
export class V4ConnectWithXhsComponent implements OnInit {
  step = 1;

  qrLoading = true;

  constructor(private modalRef: NzModalRef, private http: HttpClient) {}

  ngOnInit() {}

  onCancel() {
    this.modalRef.destroy();
  }

  onFinish() {
    this.modalRef.destroy('contact');
  }
}
